<template>
  <div>
    <div class="d-flex" id="wrapper">
      <!-- Sidebar -->
      <SideBar/>
      <!-- /#sidebar-wrapper -->
      <!-- Page Content -->
      <div id="page-content-wrapper">
        <nav style="justify-content:flex-start;" class="navbar navbar-expand-lg navbar-light bg-light border-bottom floating">
          <div>
            <button class="btn btn-outline" id="menu-toggle" @click="sidebar"><span class="navbar-toggler-icon"></span>
            </button>

            <button style="color: rgba(0,0,0,.5);border-color: rgba(0,0,0,.1);" class="btn btn-outline navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
              <span style="padding-top:0.5em;"><i class="fas fa-user-alt"></i><span class="account-div"></span><i class="fas fa-angle-down"></i></span>
            </button>
          </div>

          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
              <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  {{ admin }}
                </a>
                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                  <a class="dropdown-item link" @click="toPage('/password')"> <i class="fas fa-cog"></i><span class="right-dropdown">Change Password</span></a>
                  <a class="dropdown-item link" @click="handleLogout"><i class="fas fa-sign-out-alt"></i><span class="right-dropdown">Logout</span></a>
                </div>
              </li>
            </ul>
          </div>
        </nav>
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-md-12 grid-margin stretch-card card-div">
              <div class="container">
                <h5 class="mb-4">Dashboard</h5>
                <div class="row">
                  <div class="col-lg-2 col-md-3 col-sm-6 mt-sm-2">
                    <div class="widget-box widget-box-top link">
                      <div class="text-title text-center"> Today's New Lessee</div>
                      <div class="text-value text-center" v-if="totalTodaysNewLessee === ''"> 
                        <img src="~@/assets/images/load-button.gif"> 
                      </div>
                      <div class="text-value text-center" v-else> {{ totalTodaysNewLessee }} </div>
                    </div>
                  </div>
                  <div class="col-lg-2 col-md-3 col-sm-6 mt-sm-2">
                    <div class="widget-box widget-box-top link">
                      <div class="text-title text-center"> Today's New Order</div>
                      <div class="text-value text-center" v-if="totalTodaysNewOrder === ''"> 
                        <img src="~@/assets/images/load-button.gif"> 
                      </div>
                      <div class="text-value text-center" v-else> {{ totalTodaysNewOrder }} </div>
                    </div>
                  </div>
                  <div class="col-lg-2 col-md-3 col-sm-6 mt-sm-2">
                    <div class="widget-box widget-box-top link">
                      <div class="text-title text-center"> This Month RO (Device)</div>
                      <div class="text-value text-center" v-if="thisMonthRODevice === ''"> 
                        <img src="~@/assets/images/load-button.gif"> 
                      </div>
                      <div class="text-value text-center" v-else> {{ thisMonthRODevice }} </div>
                    </div>
                  </div>
                  <div class="col-lg-2 col-md-3 col-sm-6 mt-sm-2">
                    <div class="widget-box widget-box-top link">
                      <div class="text-title text-center"> This Month RO (Lessee)</div>
                      <div class="text-value text-center" v-if="thisMonthROLessee === ''"> 
                        <img src="~@/assets/images/load-button.gif"> 
                      </div>
                      <div class="text-value text-center" v-else> {{ thisMonthROLessee }} </div>
                    </div>
                  </div>
                  <div class="col-lg-2 col-md-3 col-sm-6 mt-sm-2">
                    <div class="widget-box widget-box-top link">
                      <div class="text-title text-center"> Total Registered Lessor</div>
                      <div class="text-value text-center" v-if="totalRegisteredLessor === ''"> 
                        <img src="~@/assets/images/load-button.gif"> 
                      </div>
                      <div class="text-value text-center" v-else> {{ totalRegisteredLessor }} </div>
                    </div>
                  </div>
                  <div class="col-lg-2 col-md-3 col-sm-6 mt-sm-2">
                    <div class="widget-box widget-box-top link">
                      <div class="text-title text-center"> Total Lessor Points</div>
                      <div class="text-value text-center" v-if="totalLessorPoints === ''"> 
                        <img src="~@/assets/images/load-button.gif"> 
                      </div>
                      <div class="text-value text-center" v-else> {{ totalLessorPoints }} </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-2 col-md-3 col-sm-6 mt-sm-2">
                    <div class="widget-box link">
                      <div class="text-title text-center"> Total Registered Lessee</div>
                      <div class="text-value text-center" v-if="totalRegisteredLessee === ''"> 
                        <img src="~@/assets/images/load-button.gif"> 
                      </div>
                      <div class="text-value text-center" v-else> {{ totalRegisteredLessee }} </div>
                    </div>
                  </div>
                  <div class="col-lg-2 col-md-3 col-sm-6 mt-sm-2">
                    <div class="widget-box link">
                      <div class="text-title text-center"> Total Active Lessee</div>
                      <div class="text-value text-center" v-if="totalActiveLessee === ''"> 
                        <img src="~@/assets/images/load-button.gif"> 
                      </div>
                      <div class="text-value text-center" v-else> {{ totalActiveLessee }} </div>
                    </div>
                  </div>
                  <div class="col-lg-2 col-md-3 col-sm-6 mt-sm-2">
                    <div class="widget-box link">
                      <div class="text-title text-center"> This Month New Lessee</div>
                      <div class="text-value text-center" v-if="thisMonthNewLessee === ''"> 
                        <img src="~@/assets/images/load-button.gif"> 
                      </div>
                      <div class="text-value text-center" v-else> {{ thisMonthNewLessee}} </div>
                    </div>
                  </div>
                  <div class="col-lg-2 col-md-3 col-sm-6 mt-sm-2">
                    <div class="widget-box link">
                      <div class="text-title text-center"> Total Registered Admin</div>
                      <div class="text-value text-center" v-if="totalRegisteredAdmin === ''"> 
                        <img src="~@/assets/images/load-button.gif"> 
                      </div>
                      <div class="text-value text-center" v-else> {{ totalRegisteredAdmin }} </div>
                    </div>
                  </div>
                  <div class="col-lg-2 col-md-3 col-sm-6 mt-sm-2">
                    <div class="widget-box link">
                      <div class="text-title text-center"> This Month New Admin</div>
                      <div class="text-value text-center" v-if="thisMonthNewAdmin === ''"> 
                        <img src="~@/assets/images/load-button.gif"> 
                      </div>
                      <div class="text-value text-center" v-else> {{ thisMonthNewAdmin }} </div>
                    </div>
                  </div>
                  <div class="col-lg-2 col-md-3 col-sm-6 mt-sm-2">
                    <div class="widget-box link">
                      <div class="text-title text-center"> This Month Cancelled Order</div>
                      <div class="text-value text-center" v-if="thisMonthCancelledOrder === ''"> 
                        <img src="~@/assets/images/load-button.gif"> 
                      </div>
                      <div class="text-value text-center" v-else> {{ thisMonthCancelledOrder }} </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-2 col-md-3 col-sm-6 mt-sm-2">
                    <div class="widget-box link">
                      <div class="text-title text-center"> Total Created Order</div>
                      <div class="text-value text-center" v-if="totalCreatedOrder === ''"> 
                        <img src="~@/assets/images/load-button.gif"> 
                      </div>
                      <div class="text-value text-center" v-else> {{ totalCreatedOrder }} </div>
                    </div>
                  </div>
                  <div class="col-lg-2 col-md-3 col-sm-6 mt-sm-2">
                    <div class="widget-box link">
                      <div class="text-title text-center"> Total Active Order</div>
                      <div class="text-value text-center" v-if="totalActiveOrder === ''"> 
                        <img src="~@/assets/images/load-button.gif"> 
                      </div>
                      <div class="text-value text-center" v-else> {{ totalActiveOrder }} </div>
                    </div>
                  </div>
                  <div class="col-lg-2 col-md-3 col-sm-6 mt-sm-2">
                    <div class="widget-box link">
                      <div class="text-title text-center"> Total Rented Device</div>
                      <div class="text-value text-center" v-if="totalRentedDevice === ''"> 
                        <img src="~@/assets/images/load-button.gif"> 
                      </div>
                      <div class="text-value text-center" v-else> {{ totalRentedDevice }} </div>
                    </div>
                  </div>
                  <div class="col-lg-2 col-md-3 col-sm-6 mt-sm-2">
                    <div class="widget-box link">
                      <div class="text-title text-center"> Total Active Device</div>
                      <div class="text-value text-center" v-if="totalActiveDevice === ''"> 
                        <img src="~@/assets/images/load-button.gif"> 
                      </div>
                      <div class="text-value text-center" v-else> {{ totalActiveDevice }} </div>
                    </div>
                  </div>
                  <div class="col-lg-2 col-md-3 col-sm-6 mt-sm-2">
                    <div class="widget-box link">
                      <div class="text-title text-center"> This Month New Rented Device</div>
                      <div class="text-value text-center" v-if="thisMonthNewDevice === ''"> 
                        <img src="~@/assets/images/load-button.gif"> 
                      </div>
                      <div class="text-value text-center" v-else> {{ thisMonthNewDevice }} </div>
                    </div>
                  </div>
                  <div class="col-lg-2 col-md-3 col-sm-6 mt-sm-2">
                    <div class="widget-box link">
                      <div class="text-title text-center"> Avg. Hour of Complain Solving</div>
                      <div class="text-value text-center" v-if="avgDayofComplainSolving === ''"> 
                        <img src="~@/assets/images/load-button.gif"> 
                      </div>
                      <div class="text-value text-center" v-else> {{ avgDayofComplainSolving }} </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-2 col-md-3 col-sm-6 mt-sm-2">
                    <div class="widget-box link">
                      <div class="text-title text-center"> Order - Pending</div>
                      <div class="text-value text-center" v-if="totalOrderPending === ''"> 
                        <img src="~@/assets/images/load-button.gif"> 
                      </div>
                      <div class="text-value text-center" v-else> {{ totalOrderPending }} </div>
                    </div>
                  </div>
                  <div class="col-lg-2 col-md-3 col-sm-6 mt-sm-2">
                    <div class="widget-box link">
                      <div class="text-title text-center"> Order - On Process</div>
                      <div class="text-value text-center" v-if="totalOrderOnProcess === ''"> 
                        <img src="~@/assets/images/load-button.gif"> 
                      </div>
                      <div class="text-value text-center" v-else> {{ totalOrderOnProcess }} </div>
                    </div>
                  </div>
                  <div class="col-lg-2 col-md-3 col-sm-6 mt-sm-2">
                    <div class="widget-box link">
                      <div class="text-title text-center"> Order - Quotation Review</div>
                      <div class="text-value text-center" v-if="totalOrderQuotationReview === ''"> 
                        <img src="~@/assets/images/load-button.gif"> 
                      </div>
                      <div class="text-value text-center" v-else> {{ totalOrderQuotationReview }} </div>
                    </div>
                  </div>
                  <div class="col-lg-2 col-md-3 col-sm-6 mt-sm-2">
                    <div class="widget-box link">
                      <div class="text-title text-center"> Order - Document Verification</div>
                      <div class="text-value text-center" v-if="totalOrderDocumentVerification === ''"> 
                        <img src="~@/assets/images/load-button.gif"> 
                      </div>
                      <div class="text-value text-center" v-else> {{ totalOrderDocumentVerification }} </div>
                    </div>
                  </div>
                  <!-- <div class="col-lg-2 col-md-3 col-sm-6 mt-sm-2">
                    <div class="widget-box link">
                      <div class="text-title text-center"> Order - Agreement Review</div>
                      <div class="text-value text-center" v-if="totaLessee === ''"> 
                        <img src="~@/assets/images/load-button.gif"> 
                      </div>
                      <div class="text-value text-center" v-else> {{ toag }} </div>
                    </div>
                  </div> -->
                  <div class="col-lg-2 col-md-3 col-sm-6 mt-sm-2">
                    <div class="widget-box link">
                      <div class="text-title text-center"> Order - Waiting for Payment</div>
                      <div class="text-value text-center" v-if="totalOrderWaitingforPayment === ''"> 
                        <img src="~@/assets/images/load-button.gif"> 
                      </div>
                      <div class="text-value text-center" v-else> {{ totalOrderWaitingforPayment }} </div>
                    </div>
                  </div>
                  <div class="col-lg-2 col-md-3 col-sm-6 mt-sm-2">
                    <div class="widget-box link">
                      <div class="text-title text-center"> Order - Ready to Book</div>
                      <div class="text-value text-center" v-if="totalOrderReadytoBook === ''"> 
                        <img src="~@/assets/images/load-button.gif"> 
                      </div>
                      <div class="text-value text-center" v-else> {{ totalOrderReadytoBook }} </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-2 col-md-3 col-sm-6 mt-sm-2">
                    <div class="widget-box link">
                      <div class="text-title text-center"> Order - Ready to Pickup</div>
                      <div class="text-value text-center" v-if="totalOrderReadytoPickup === ''"> 
                        <img src="~@/assets/images/load-button.gif"> 
                      </div>
                      <div class="text-value text-center" v-else> {{ totalOrderReadytoPickup }} </div>
                    </div>
                  </div>
                  <div class="col-lg-2 col-md-3 col-sm-6 mt-sm-2">
                    <div class="widget-box link">
                      <div class="text-title text-center"> Order - Picking Up</div>
                      <div class="text-value text-center" v-if="totalOrderPickingUp === ''"> 
                        <img src="~@/assets/images/load-button.gif"> 
                      </div>
                      <div class="text-value text-center" v-else> {{ totalOrderPickingUp }} </div>
                    </div>
                  </div>
                  <div class="col-lg-2 col-md-3 col-sm-6 mt-sm-2">
                    <div class="widget-box link">
                      <div class="text-title text-center"> Order - Ready to Prepare</div>
                      <div class="text-value text-center" v-if="totalOrderReadytoPrepare === ''"> 
                        <img src="~@/assets/images/load-button.gif"> 
                      </div>
                      <div class="text-value text-center" v-else> {{ totalOrderReadytoPrepare }} </div>
                    </div>
                  </div>
                  <div class="col-lg-2 col-md-3 col-sm-6 mt-sm-2">
                    <div class="widget-box link">
                      <div class="text-title text-center"> Order - Prepared</div>
                      <div class="text-value text-center" v-if="totalOrderPrepared === ''"> 
                        <img src="~@/assets/images/load-button.gif"> 
                      </div>
                      <div class="text-value text-center" v-else> {{ totalOrderPrepared }} </div>
                    </div>
                  </div>
                  <div class="col-lg-2 col-md-3 col-sm-6 mt-sm-2">
                    <div class="widget-box link">
                      <div class="text-title text-center"> Order - Ready to Deliver</div>
                      <div class="text-value text-center" v-if="totalOrderReadytoDeliver === ''"> 
                        <img src="~@/assets/images/load-button.gif"> 
                      </div>
                      <div class="text-value text-center" v-else> {{ totalOrderReadytoDeliver }} </div>
                    </div>
                  </div>
                  <div class="col-lg-2 col-md-3 col-sm-6 mt-sm-2">
                    <div class="widget-box link">
                      <div class="text-title text-center"> Order - On Shipping</div>
                      <div class="text-value text-center" v-if="totalOrderOnShipping === ''"> 
                        <img src="~@/assets/images/load-button.gif"> 
                      </div>
                      <div class="text-value text-center" v-else> {{ totalOrderOnShipping }} </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-2 col-md-3 col-sm-6 mt-sm-2">
                    <div class="widget-box link">
                      <div class="text-title text-center"> Order - On Renting</div>
                      <div class="text-value text-center" v-if="totalOrderOnRenting === ''"> 
                        <img src="~@/assets/images/load-button.gif"> 
                      </div>
                      <div class="text-value text-center" v-else> {{ totalOrderOnRenting }} </div>
                    </div>
                  </div>
                  <div class="col-lg-2 col-md-3 col-sm-6 mt-sm-2">
                    <div class="widget-box link">
                      <div class="text-title text-center"> Order - Finished Rent</div>
                      <div class="text-value text-center" v-if="totalOrderFinished === ''"> 
                        <img src="~@/assets/images/load-button.gif"> 
                      </div>
                      <div class="text-value text-center" v-else> {{ totalOrderFinished }} </div>
                    </div>
                  </div>
                  <div class="col-lg-2 col-md-3 col-sm-6 mt-sm-2">
                    <div class="widget-box link">
                      <div class="text-title text-center"> Order - Completed Rent</div>
                      <div class="text-value text-center" v-if="totalOrderCompleted === ''"> 
                        <img src="~@/assets/images/load-button.gif"> 
                      </div>
                      <div class="text-value text-center" v-else> {{ totalOrderCompleted }} </div>
                    </div>
                  </div>
                  <div class="col-lg-2 col-md-3 col-sm-6 mt-sm-2">
                    <div class="widget-box link">
                      <div class="text-title text-center"> Avg. Day of Paid - Handover</div>
                      <div class="text-value text-center" v-if="avgDayofPaidtoHandover === ''"> 
                        <img src="~@/assets/images/load-button.gif"> 
                      </div>
                      <div class="text-value text-center" v-else> {{ avgDayofPaidtoHandover }} </div>
                    </div>
                  </div>
                  <div class="col-lg-2 col-md-3 col-sm-6 mt-sm-2">
                    <div class="widget-box link">
                      <div class="text-title text-center"> Avg. Day of Paid - Ready to Prepare</div>
                      <div class="text-value text-center" v-if="avgDayofPaidReadytoPrepare === ''"> 
                        <img src="~@/assets/images/load-button.gif"> 
                      </div>
                      <div class="text-value text-center" v-else> {{ avgDayofPaidReadytoPrepare }} </div>
                    </div>
                  </div>
                  <div class="col-lg-2 col-md-3 col-sm-6 mt-sm-2">
                    <div class="widget-box link">
                      <div class="text-title text-center"> Avg. Day of Ready to Prepare - Handover</div>
                      <div class="text-value text-center" v-if="avgDayofReadytoPrepareHandover === ''"> 
                        <img src="~@/assets/images/load-button.gif"> 
                      </div>
                      <div class="text-value text-center" v-else> {{ avgDayofReadytoPrepareHandover }} </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /#page-content-wrapper -->

    </div>
  </div>
</template>

<script>
  import SideBar from './SideBar'
  export default {
    name: 'Home',
    components:{
      SideBar
    },
  data () {
    return {
      admin:"",
      permission:[],
      viewDashboard: false,
      viewOrder: false,
      viewProduct: false,
      viewPayment: false,
      viewResolution: false,
      viewPartner: false,
      expired:false,
      totalTodaysNewLessee:'',
      totalTodaysNewOrder:'',
      thisMonthRODevice:'',
      thisMonthROLessee:'',
      totalRegisteredLessor:'',
      totalLessorPoints:'',
      totalRegisteredLessee:'',
      totalActiveLessee:'',
      thisMonthNewLessee:'',
      totalRegisteredAdmin:'',
      thisMonthNewAdmin:'',
      thisMonthCancelledOrder:'',
      totalCreatedOrder:'',
      totalActiveOrder:'',
      totalRentedDevice:'',
      totalActiveDevice:'',
      thisMonthNewDevice:'',
      avgDayofPaidtoHandover:'',
      avgDayofComplainSolving:'',
      avgDayofPaidReadytoPrepare:'',
      avgDayofReadytoPrepareHandover:'',
      totalOrderPending:'',
      totalOrderOnProcess:'',
      totalOrderQuotationReview:'',
      // totalOrderVerification:'',
      totalOrderDocumentVerification:'',
      totalOrderWaitingforPayment:'',
      totalOrderReadytoBook:'',
      totalOrderReadytoPickup:'',
      totalOrderPickingUp:'',
      totalOrderReadytoPrepare:'',
      totalOrderPrepared:'',
      totalOrderReadytoDeliver:'',
      totalOrderOnShipping:'',
      totalOrderOnRenting:'',
      totalOrderFinished:'',
      totalOrderCompleted:'',
    }
  },
  methods: {
    toPage(e) {
      this.$router.push(e)
    },
    async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
      localStorage.removeItem('jwt')
      localStorage.removeItem('admin_name')
      localStorage.removeItem('roles')
      localStorage.removeItem('user_email')
      localStorage.removeItem('admin_id')
      localStorage.removeItem('changeCatalogPermission')
      this.$router.push('/')
    },
    cekLogin(){
      if (localStorage.getItem('jwt') == null) {
          this.$router.push('/')
      }
    },
    cekPermission(){
      this.permission = localStorage.getItem('roles')
      for(var i=0; i < this.permission.length; i++){
        if( this.permission[i] == 18){
          this.viewDashboard = true
        }else{
          this.viewDashboard = false
        }
        if( this.permission[i] == 18){
          this.viewOrder = true
        }else{
          this.viewOrder = false
        }
        if( this.permission[i] == 18){
          this.viewProduct = true
        }else{
          this.viewProduct = false
        }
      }
    },
    handleExpired(){

    },
    sidebar(){
      $("#wrapper").toggleClass("toggled");
    }
  },
  created(){
    this.admin = localStorage.getItem('admin_name')
    this.cekLogin() 
    this.cekPermission()
    this.$http.get(process.env.GET_DATA_DASHBOARD,{
          headers: {'Asani-Token':localStorage.getItem('jwt')}
        })
        .then(response => {
          if (response.data.status !== 200) {
            swal("Sorry", response.data.message, "error", {
              button: "Ok",
            })
          } else{
            this.totalTodaysNewLessee = response.data.content.totalTodaysNewLessee[0].totalNewLessee
            this.totalTodaysNewOrder = response.data.content.totalTodaysNewOrder[0].totalNewOrder
            this.thisMonthRODevice = response.data.content.thisMonthRODevice[0].totalMonthRODevice
            this.thisMonthROLessee = response.data.content.thisMonthROLessee[0].totalMonthROLessee
            this.totalRegisteredLessor = response.data.content.totalRegisteredLessor[0].totalRegisteredLessor
            this.totalLessorPoints = response.data.content.totalLessorPoints[0].totalLessorPoints
            this.totalRegisteredLessee = response.data.content.totalRegisteredLessee[0].totalRegisteredLessee
            this.totalActiveLessee = response.data.content.totalActiveLessee[0].totalActiveLessee
            this.thisMonthNewLessee = response.data.content.thisMonthNewLessee[0].totalMonthNewLessee
            this.totalRegisteredAdmin = response.data.content.totalRegisteredAdmin[0].totalRegisteredAdmin
            this.thisMonthNewAdmin = response.data.content.thisMonthNewAdmin[0].totalMonthNewAdmin
            this.thisMonthCancelledOrder = response.data.content.thisMonthCancelledOrder[0].totalMonthCancelledOrder
            this.totalCreatedOrder = response.data.content.totalCreatedOrder[0].totalOrder
            this.totalActiveOrder = response.data.content.totalActiveOrder[0].totalActiveOrder
            this.totalRentedDevice = response.data.content.totalRentedDevice[0].totalRentedDevice
            this.totalActiveDevice = response.data.content.totalActiveDevice[0].totalActiveDevice
            this.thisMonthNewDevice = response.data.content.thisMonthNewDevice[0].totalNewDevice
            this.avgDayofPaidtoHandover = response.data.content.avgDayofPaidtoHandover[0].avgDay
            this.avgDayofPaidReadytoPrepare = response.data.content.avgDayofPaidReadytoPrepare[0].avgDay
            this.avgDayofComplainSolving = response.data.content.avgDayofComplainSolving[0].avgHour
            this.avgDayofReadytoPrepareHandover = response.data.content.avgDayofReadytoPrepareHandover[0].avgDay
            this.totalOrderPending = response.data.content.orderPending[0].totalOrderPending
            this.totalOrderOnProcess = response.data.content.orderOnProcess[0].totalOrderOnProcess
            this.totalOrderQuotationReview = response.data.content.orderQuotationReview[0].totalOrderQuotationReview
            this.totalOrderDocumentVerification = response.data.content.orderDocumentVerification[0].totalOrderDocumentVerification
            // this.totalOrderAgreement = response.data.content.totalOrderAgreement[0].totalOrderAgreement
            this.totalOrderWaitingforPayment = response.data.content.orderWaitingforPayment[0].totalOrderWaitingforPayment
            this.totalOrderReadytoBook = response.data.content.orderReadytoBook[0].totalOrderReadytoBook
            this.totalOrderReadytoPickup = response.data.content.orderReadytoPickup[0].totalOrderReadytoPickup
            this.totalOrderPickingUp = response.data.content.orderPickingUp[0].totalOrderPickingUp
            this.totalOrderReadytoPrepare = response.data.content.orderReadytoPrepare[0].totalOrderReadytoPrepare
            this.totalOrderPrepared = response.data.content.orderPrepared[0].totalOrderPrepared
            this.totalOrderReadytoDeliver = response.data.content.orderReadytoDeliver[0].totalOrderReadytoDeliver
            this.totalOrderOnShipping = response.data.content.orderOnShipping[0].totalOrderOnShipping
            this.totalOrderOnRenting = response.data.content.orderOnRenting[0].totalOrderOnRenting
            this.totalOrderFinished = response.data.content.orderFinishedRent[0].totalOrderFinishedRent
            this.totalOrderCompleted = response.data.content.orderCompletedRent[0].totalOrderCompletedRent
            // this.totalOrderCancelled = response.data.content.totalOrderCancelled[0].totalOrderCancelled,
            // this.dataOrder = response.data.content.data
            // this.totalPage = response.data.content.totalPage
            // this.totalData = response.data.content.totalData
            this.loadingTable = false
          }
        })
        .catch((error) => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.text-title{
  font-size: 14px;
  /*font-weight: bold;*/
  min-height: 50px;
}

.text-value{
  font-size: 30px;
  /*font-weight: bold;*/
  margin-top: -10px;
}

.widget-box.widget-box-top{
  box-sizing: content-box;  
  width: auto;
  height: 80px;
  padding: 10px;
  border: 1px solid lightgray;
  border-radius: 5px;
  /*margin : 0px 3px;*/
  text-align: center;
  margin:auto;
  margin-top: 0px;
  -webkit-box-shadow: 0px 0px 2px 0px rgba(0,0,0,0.75);
  -moz-box-shadow: 0px 0px 2px 0px rgba(0,0,0,0.75);
  box-shadow: 0px 0px 2px 0px rgba(0,0,0,0.75);
}

.widget-box {

  box-sizing: content-box;  
  width: auto;
  height: 80px;
  padding: 10px;
  border: 1px solid lightgray;
  border-radius: 5px;
  /*margin : 0px 3px;*/
  text-align: center;
  margin:auto;
  margin-top: 15px;
  -webkit-box-shadow: 0px 0px 2px 0px rgba(0,0,0,0.75);
  -moz-box-shadow: 0px 0px 2px 0px rgba(0,0,0,0.75);
  box-shadow: 0px 0px 2px 0px rgba(0,0,0,0.75);
}

  .right-dropdown{
    margin-left: 7px;
  }
  .account-div{
    margin: 2px 2px;
  }
  .right-arrow{
    margin-left: auto;
  }
  .brand-logo{
    width: 120px;
  }
  .menu-title{
    margin-left: 1.125rem;
  }
  .menu-title-order{
    margin-left: 1.95rem;
  }
  .menu-title-payment{
    margin-left: 1.525rem;
  }

  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
    /*width: 200px;*/
    /*background-color: #f1f1f1;*/
  }

  li.sidebar a {
    display: block;
    color: #000;
    padding: 8px 63px;
    text-decoration: none;
  }

  li a.active {
    background-color: #4CAF50;
    color: white;
  }

  li a:hover:not(.active) {
    background-color: #2797FB;
    color: white;
  }
  .nav-side-menu {
    overflow: auto;
    font-family: verdana;
    font-size: 12px;
    font-weight: 200;
    background-color: #2e353d;
    position: fixed;
    top: 0px;
    width: 300px;
    height: 100%;
    color: #e1ffff;
  }
  .nav-side-menu .brand {
    background-color: #23282e;
    line-height: 50px;
    display: block;
    text-align: center;
    font-size: 14px;
  }
  .nav-side-menu .toggle-btn {
    display: none;
  }
  .nav-side-menu ul,
  .nav-side-menu li {
    list-style: none;
    padding: 0px;
    margin: 0px;
    line-height: 35px;
    cursor: pointer;
  /*    
    .collapsed{
       .arrow:before{
                 font-family: FontAwesome;
                 content: "\f053";
                 display: inline-block;
                 padding-left:10px;
                 padding-right: 10px;
                 vertical-align: middle;
                 float:right;
            }
     }
     */
   }
   .nav-side-menu ul :not(collapsed) .arrow:before,
   .nav-side-menu li :not(collapsed) .arrow:before {
    font-family: FontAwesome;
    content: "\f078";
    display: inline-block;
    padding-left: 10px;
    padding-right: 10px;
    vertical-align: middle;
  }
  .nav-side-menu ul .active,
  .nav-side-menu li .active {
    border-left: 3px solid #d19b3d;
    background-color: #4f5b69;
  }
  .nav-side-menu ul .sub-menu li.active,
  .nav-side-menu li .sub-menu li.active {
    color: #d19b3d;
  }
  .nav-side-menu ul .sub-menu li.active a,
  .nav-side-menu li .sub-menu li.active a {
    color: #d19b3d;
  }
  .nav-side-menu ul .sub-menu li,
  .nav-side-menu li .sub-menu li {
    background-color: #181c20;
    border: none;
    line-height: 28px;
    border-bottom: 1px solid #23282e;
    margin-left: 0px;
  }
  .nav-side-menu ul .sub-menu li:hover,
  .nav-side-menu li .sub-menu li:hover {
    background-color: #020203;
  }
  .nav-side-menu ul .sub-menu li:before,
  .nav-side-menu li .sub-menu li:before {
    font-family: FontAwesome;
    content: "\f105";
    display: inline-block;
    padding-left: 10px;
    padding-right: 10px;
    vertical-align: middle;
  }
  .nav-side-menu li {
    padding-left: 0px;
    border-left: 3px solid #2e353d;
    border-bottom: 1px solid #23282e;
  }
  .nav-side-menu li a {
    text-decoration: none;
    color: #e1ffff;
  }
  .nav-side-menu li a i {
    padding-left: 10px;
    width: 20px;
    padding-right: 20px;
  }
  .nav-side-menu li:hover {
    border-left: 3px solid #d19b3d;
    background-color: #4f5b69;
    -webkit-transition: all 1s ease;
    -moz-transition: all 1s ease;
    -o-transition: all 1s ease;
    -ms-transition: all 1s ease;
    transition: all 1s ease;
  }
  @media (max-width: 767px) {
    .nav-side-menu {
      position: relative;
      width: 100%;
      margin-bottom: 10px;
    }
    .nav-side-menu .toggle-btn {
      display: block;
      cursor: pointer;
      position: absolute;
      right: 10px;
      top: 10px;
      z-index: 10 !important;
      padding: 3px;
      background-color: #ffffff;
      color: #000;
      width: 40px;
      text-align: center;
    }
    .brand {
      text-align: left !important;
      font-size: 22px;
      padding-left: 20px;
      line-height: 50px !important;
    }
  }
  @media (min-width: 767px) {
    .nav-side-menu .menu-list .menu-content {
      display: block;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/DashboardPage.vue